const buttons = document.querySelectorAll('.ns-button');

for (const button of buttons) {
    button.addEventListener('click', e => {
        if (button.classList.contains('ns-button_disabled')) {
            e.preventDefault();
        }
    })
}
